// extracted by mini-css-extract-plugin
export default {"page":"App_page__5vKaD","header":"App_header__fhC8n","body":"App_body__PuluK","footer":"App_footer__aawhi"};